import { render, staticRenderFns } from "./MigrationPodium.vue?vue&type=template&id=45f57c9c&scoped=true&"
import script from "./MigrationPodium.vue?vue&type=script&lang=js&"
export * from "./MigrationPodium.vue?vue&type=script&lang=js&"
import style0 from "./MigrationPodium.vue?vue&type=style&index=0&id=45f57c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f57c9c",
  null
  
)

export default component.exports